import { render } from "./FormLevel1.vue?vue&type=template&id=3b63699d&scoped=true"
import script from "./FormLevel1.vue?vue&type=script&lang=js"
export * from "./FormLevel1.vue?vue&type=script&lang=js"

import "./FormLevel1.vue?vue&type=style&index=0&id=3b63699d&scoped=true&lang=css"

import exportComponent from "/home/zhayrullah/projects/laravel/mawthuq/front-mawthuq/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b63699d"]])

export default __exports__